const white = '#FFFFFF';
const black = '#000000';

const Colors = {
  transparent: 'transparent',
  white,
  black,
  text_1: '#101820',
  text_2: '#19447a',
  gray_1: '#f5f7ff',
  gray_2: '#a1a5c0',
  gray_3: '#A1A5C0',
  gray_4: '#e3eef5',
  gray_5: '#ebf7ff',
};

export default Colors;
